<template>
  <div style='position: relative;'>
    <a href='#' v-if='!edit' class='button button--success' @click.prevent.stop="isShown = true"><i class='fas fa-plus'></i>New</a>
    <a href='#' v-if='edit' class='button button--secondary' @click.prevent.stop="isShown = true">Edit Folder</a>
    <div class='duplicator right' v-if='isShown'>
      <span v-if='edit'><b>Edit Folder</b></span>
      <slot></slot>
      <a href='#' class='button button--secondary' @click.prevent.stop="isShown = false">Cancel</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "edit"],
  mounted () {
    
  },
  data () {
    return {
      isShown: false
    }
  }
}
</script>

